import { render } from "./AdvCreateCategorySelection.vue?vue&type=template&id=73876e24"
import script from "./AdvCreateCategorySelection.vue?vue&type=script&lang=js"
export * from "./AdvCreateCategorySelection.vue?vue&type=script&lang=js"

import "./AdvCreateCategorySelection.vue?vue&type=style&index=0&id=73876e24&lang=scss"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__